import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./PublicLayout.css";

function PublicHeader() {
  return (
    <header className="public-header">
      <div className="public-container">
        <Link to="/" className="public-brand">
          <img src={logo} alt="Zinea" className="public-logo" />
          <span className="public-brand-name">Zinea</span>
        </Link>
        <nav className="public-nav">
          <NavLink to="/about" className="public-nav-link">
            About
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default PublicHeader;
